import { Link } from 'react-router-dom';

import type { MachineSummary } from '../types/machine';

export function MachineRow({ machine, canRestore = false, restoring = false, onRestore }: {
  machine: MachineSummary;
  canRestore?: boolean;
  restoring?: boolean;
  onRestore?: (machine: MachineSummary) => void;
}) {
  const secondary = [machine.machineType, machine.manufacturer, machine.model, machine.location]
    .filter(Boolean)
    .join(' • ');

  const identity = (
    <>
      <div className="r42-machine-row__icon" aria-hidden="true">
        <i className="bi bi-gear-wide-connected" />
      </div>
      <div className="r42-machine-row__body">
        <strong>{machine.name}</strong>
        <span>{secondary || machine.assetId || 'Machine workspace'}</span>
        {machine.status === 'archived' ? <small>Machine Memory and history are preserved.</small> : null}
      </div>
    </>
  );

  if (machine.status === 'archived') {
    return (
      <article className="r42-machine-row r42-machine-row--archived">
        {identity}
        <div className="r42-machine-row__meta">
          <span className="r42-status r42-status--archived">Archived</span>
          {canRestore && onRestore ? (
            <button className="btn btn-sm r42-btn-primary" type="button" aria-label={`Restore ${machine.name}`} onClick={() => onRestore(machine)} disabled={restoring}>
              {restoring ? 'Restoring…' : 'Restore machine'}
            </button>
          ) : <span className="r42-machine-row__permission-note">Restore access required</span>}
        </div>
      </article>
    );
  }

  return (
    <Link className="r42-machine-row" to={`/machines/${machine.id}`}>
      {identity}
      <div className="r42-machine-row__meta">
        <span className="r42-status r42-status--current">Active</span>
        <i className="bi bi-chevron-right" aria-hidden="true" />
      </div>
    </Link>
  );
}
